module.exports = __webpack_public_path__ + "static/media/cat-duotone.794f5b58.svg";